import * as Yup from 'yup'
import StringUtil from 'utils/string-util'
import { PAYMENT_STATUS } from 'domains/customer-order/constants/customer-order-constants'

/**
 * Update Customer Order Payment status manually schema */
const customerOrderPaymentUpdateStatusSchema = Yup.object().shape({
  status: Yup.string().oneOf(
    Object.values(PAYMENT_STATUS),
    `Must be one of this value: ${Object.values(PAYMENT_STATUS).map((status) => StringUtil.humanize(status)).join(', ')}`
  ).required('Required'),
  payment_method_transaction_no: Yup.string().when('payment_method.category', {
    is   : (value) => value === 'offline',
    then : Yup.string().required('Required')
  })
})

export default customerOrderPaymentUpdateStatusSchema
